export default __webpack_public_path__ + "static/media/landing-play-button.1e887c46.svg";